import { render, staticRenderFns } from "./bookkeeping.vue?vue&type=template&id=1d776a9f&scoped=true&"
import script from "./bookkeeping.vue?vue&type=script&lang=js&"
export * from "./bookkeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d776a9f",
  null
  
)

export default component.exports